export const SHOW_ONLY_ARCHIVED_JOBS_FILTER = 'show_archived_jobs_only';
export const SHOW_ALL_JOBS_FILTER = 'show_archived_jobs';
